import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";

export type { DiscountState } from "./shared";

export const cartSlice = createSlice({
  // Renamed from "checkout" (which web's CheckoutSlice also uses) — see ./shared for why
  // that was safe. Action types are now `cart/…`.
  name: "cart",
  initialState: sharedInitialState,
  reducers: {
    ...sharedReducers,
  },
  // Both bodies are empty in the app source — the cases exist but reset nothing.
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {

      })
      .addCase(supportLogout, (state) => {

      });
  },
});

export const {
  toggleCartState,
  resetServiceModeData,
  updateCartSlice
} = cartSlice.actions;
export default cartSlice.reducer;
